module.exports = __webpack_public_path__ + "img/loading.a15ee5d4.png";